// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Media from "./Media.res.js";
import * as React from "react";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReactDomElement from "./ReactDomElement.res.js";

function use(forwardedRef, touchscreenVisibleOpt, param) {
  let touchscreenVisible = touchscreenVisibleOpt !== undefined ? touchscreenVisibleOpt : false;
  let match = React.useState(() => false);
  let setState = match[1];
  let ref = forwardedRef !== undefined ? forwardedRef : React.useRef(null);
  let touchscreen = Media.use("(hover: none)");
  React.useEffect(() => {
    let onMouseEnter = _evt => setState(param => true);
    let onMouseLeave = _evt => setState(param => false);
    Stdlib_Option.map(ReactDomElement.fromRef(ref), domElement => {
      domElement.addEventListener("mouseenter", onMouseEnter);
      domElement.addEventListener("mouseleave", onMouseLeave);
    });
    return () => {
      Stdlib_Option.map(ReactDomElement.fromRef(ref), domElement => {
        domElement.removeEventListener("mouseenter", onMouseEnter);
        domElement.removeEventListener("mouseleave", onMouseLeave);
      });
    };
  }, [ref.current]);
  let state = touchscreenVisible && touchscreen ? true : match[0];
  return [
    ref,
    state
  ];
}

export {
  use,
}
/* Media Not a pure module */
